
import { InfoItemHorizontal } from "components"
import { ButtonCancel } from "components2"
import { Formik } from "formik"
import { Card, Modal, Nav, Tab } from "react-bootstrap"
import { remoteFilePath } from "../utils/remoteFilePath"
import { ListItemPerubahanData } from "./ListItemPerubahanData"
import { TabFile } from "./TabFile"
import { TabGambar } from "./TabGambar"

export const ModalDetailItemPerubahanData = ({ modal, dismissModal }) => {
  const data = modal.data
  console.log(data)

  return (
    <Modal
      scrollable
      size="lg"
      show={modal.show}
      onHide={() => dismissModal()}>
      <Modal.Header closeButton>Detail Item Perubahan Data</Modal.Header>

      <Modal.Body>
        <InfoItemHorizontal label="Modul" text={data?.kode_modul} />
        <InfoItemHorizontal label="Menu" text={data?.kode_menu} />
        <InfoItemHorizontal label="No. Referensi Transaksi" text={data?.no_referensi_transaksi} />

        <div className="mt-4">
          <div>
            <small className="font-weight-bold">Detail Perubahan</small>
          </div>
          <ListItemPerubahanData
            showInputForm={false}
            showActionColumn={false}
            data={data?.atribut}
          />
        </div>

        <Formik
          enableReinitialize
          initialValues={{
            gambar: data?.gambar.map(g => ({ ...g, link: remoteFilePath(g.path_file).full })) ?? [],
            file: data?.file.map(f => ({ ...f, nama: f.path_file?.split("/")?.pop(), link: remoteFilePath(f.path_file).full })) ?? []
          }} >
          {({ values }) => {
            console.log(values)
            return (
              <Card className="mt-4">
                <Tab.Container defaultActiveKey="gambar">
                  <Card.Header>
                    <Nav variant="tabs">
                      <Nav.Item>
                        <Nav.Link eventKey="gambar">Gambar</Nav.Link>
                      </Nav.Item>
                      <Nav.Item>
                        <Nav.Link eventKey="documents">File</Nav.Link>
                      </Nav.Item>
                    </Nav>
                  </Card.Header>

                  <Card.Body>
                    <Tab.Content>
                      <Tab.Pane eventKey="gambar">
                        <TabGambar
                          type="DETAIL"
                          dataGambar={values.gambar ?? []}
                        />
                      </Tab.Pane>

                      <Tab.Pane eventKey="documents">
                        <TabFile
                          type="DETAIL"
                          dataFile={values.file ?? []}
                        />
                      </Tab.Pane>
                    </Tab.Content>
                  </Card.Body>
                </Tab.Container>
              </Card>
            )
          }}
        </Formik >
      </Modal.Body>

      <Modal.Footer>
        <div className="d-flex justify-content-center">
          <ButtonCancel
            className="mr-2"
            onClick={() => dismissModal()}
          />
        </div>
      </Modal.Footer>
    </Modal>
  )
}